import BookIcon from '@material-ui/icons/Book'
import DeviceList from './DeviceList'

export default {
  list: DeviceList,
  icon: BookIcon,
}
